export const C_LOGIN_REQUEST = "C_LOGIN_REQUEST";
export const C_LOGIN_FAIL = "C_LOGIN_FAIL";
export const C_LOGIN_SUCCESS = "C_LOGIN_SUCCESS";
export const C_LOAD_USER_REQUEST = "C_LOAD_USER_REQUEST";
export const C_LOAD_USER_SUCCESS = "C_LOAD_USER_SUCCESS";
export const C_LOAD_USER_FAIL = "C_LOAD_USER_FAIL";
export const C_LOGOUT_SUCCESS = "C_LOGOUT_SUCCESS";
export const C_LOGOUT_FAIL = "C_LOGOUT_FAIL";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
